/**
 * 退款登记 窗口
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import { Button, message, Spin,Alert,Empty,Modal } from "antd";
import Lang from "@/components/Lang/Lang";
import EssaModal from "@/components/EssaModal/EssaModal";
import ViewImage from '@components/UploadFile/UploadImage/ViewImage';
// import UploadImage from '@components/UploadFile/UploadImage/UploadImage';
import UploadFile from '@components/UploadFile/UploadFile';
import FnanceAction from "../Fnance.action";
import "./RefundRegistration.less"

class RefundRegistrationModal extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showModal: false,
        }
    }
    //不需要退款的提示
    showNotRefund(){
        Modal.confirm({
            title:Lang({id:'TiShi',default:'提示'}),
            content: Lang({id:'QingZaiCaiWuXiTongChuLiHo',default:'请在财务系统处理后进行操作完成，该笔退款不需要退款给客户'}),
            icon: null,
            okText:Lang({id:'QueDing',default:'确定'}),
            cancelText:Lang({id:'QuXiao',default:'取消'}),
            okButtonProps: {
                style: {
                    backgroundColor: '#A4373A',
                    borderColor: '#A4373A'
                }
            },
            onOk: () => {
                const {row,readOnly} = this.props;
                this.loading(true);
                const postData = {
                    id: row.id,
                    serviceTypeCode: row.serviceTypeCode,
                }
                FnanceAction.refundDisposeAdd(postData).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err));
            },
            onCancel: () => {
                // 用户取消，不执行任何操作
            }
        });
    }
    /**
     * 弹窗
     * */
    openModal(flag,){
        if(flag){//取消时清空数据
            const {row,readOnly} = this.props;
            if(row.isNeedRefund!=1){//不需要退款的提示
                this.showNotRefund();
            }else{
                this.setState({
                    showModal: flag
                })
            }
        }else {
            this.setState({
                showModal: flag,
                paymentSlipFile: {}
            })
        }
    }
    loading(flag=false){
        this.setState({
            loading: flag
        })
    }
    handleOk(){
        const { paymentSlipFile } = this.state;
        const {row,} = this.props;
        if(paymentSlipFile&&paymentSlipFile.fileId){
            this.loading(true);
            const postData = {
                id: row.id,
                serviceTypeCode: row.serviceTypeCode,
                paymentSlipFileId: paymentSlipFile.fileId,
            }
            FnanceAction.refundDisposeAdd(postData).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err));
        }else {
            message.open({
                type: 'info',
                content: Lang({id: 'QingXuanZeWenJian', default: '请选择文件'}),
            });
        }
    }
    handleRes(response={}){
        this.loading(false);
        if (response.success && response.valid) {
            message.open({
                type: 'success',
                content: Lang({id: 'CaoZuoChengGong', default: '操作成功'}),
            });
            //重置内容
            this.openModal(false);
            // 刷新 页面数据
            setTimeout(()=>{
               if(this.props.refreshPage)this.props.refreshPage();
            },200)
        }else if (response.message){
            message.open({
                type: 'info',
                content: response.message,
            });
        }else{
            message.open({
                type: 'warning',
                content: Lang({id: 'CaoZuoShiBai',default:'操作失败'}),
            });
        }
    }
    // 修改文件上传
    onChange(dat){
        if(dat&&dat.length>0){
            this.setState({
                paymentSlipFile:dat[0]
            })
        }
    }
    render(){
        const {readOnly,children,paymentSlipFileUrl} = this.props;
        const {loading, showModal, submitLoading=false} = this.state;
        return (<Spin spinning={loading}>
                <span onClick={()=>this.openModal(true)}>{children}</span>
                {showModal&&<EssaModal title={Lang({id: "TuiKuanDengJi2",default: "退款登记"})}
                                                open={showModal}
                                                width={600}
                                                // onOk={()=>this.handleOk()}
                                                // cancelText={Lang({id: "ShaoHouZaiChuLi",default: "稍后再处理"})}
                                                // okText={Lang({id: "WanChengDengJi",default: "完成登记"})}
                                                onCancel={()=>this.openModal(false)}
                                       footer={null}>
                    <Spin spinning={loading}>
                        <div className={"RefundRegistrationWrap"}>
                            <Alert message={Lang({id: "JiKeHuHuiKuanHouJiangFuKu",default: "给客户汇款后，将付款凭证上传到系统，供客户查看"})}
                                   type="info" showIcon className={"payTips"} />
                            <div className={"mt_16"}>
                                {readOnly?<div>
                                    {paymentSlipFileUrl?<ViewImage initValue={[
                                        {fileUrl:paymentSlipFileUrl}
                                    ]} />:<Empty description={Lang({id: "ZanWuShuJu", default: "暂无数据"})} className="mt_40 mb_40"></Empty>}
                                </div>: <UploadFile onChange={(dat)=>this.onChange(dat)}
                                                    accept={".pdf, .jpg, .jpeg, .png"}
                                                    multiple={false}
                                                    maxCount={1}   />}
                                {/*<UploadImage accept={".pdf, .jpg, .jpeg, .png"}*/}
                                             {/*onChange={(dat)=>this.onChange(dat)}*/}
                                             {/*multiple={false}*/}
                                             {/*styleName={"UploadImageBox"}*/}
                                             {/*maxCount={1} />*/}
                                {readOnly?null:<div className={"mt_8 text-center"}>
                                     <Button className={"mr_16"} onClick={()=>this.openModal(false)}>
                                         <Lang id="ShaoHouZaiChuLi">稍后再处理</Lang>
                                     </Button>
                                     <Button type="primary" loading={submitLoading} onClick={()=>this.handleOk()}>
                                         <Lang id="WanChengDengJi">完成登记</Lang>
                                     </Button>
                                 </div>}
                            </div>
                        </div>
                    </Spin>
                </EssaModal>}
            </Spin>
        )
    }
}

export default RefundRegistrationModal;
